import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import DetailsPanel from "components/Elements/DetailsPanel";
import EMIChip from "components/Elements/EMIChip/EMIChip";
import ModelTaskTable from "components/Modules/ModelTaskTable";
import TaskSearchFilters from "./TaskSearchFilters";

const useStyles = makeStyles()(() => ({
	loading: {
		position: "absolute",
		width: "100%",
		left: 0,
		top: 0,
	},
}));

const ModelTaskWorkspace = ({
	rows,
	totalCount,
	search,
	onSearchChange,
	chips,
	removeChip,
	autocompleteData,
	isSearchingSuggestions,
	handleSelectSuggestion,
	tableConfiguration,
	query,
	customCaptions,
	modelId,
	access,
	deleteEndpoint,
	sorting,
	onSortingChange,
	onDelete,
	onCopy,
	onCopyTaskQuestion,
	onRefresh,
	initialExpandedIds,
	initialPrimaryId,
}) => {
	const { classes } = useStyles();
	const { t } = useTranslation();

	return (
		<>
			<div className="detailsContainer" style={{ alignItems: "center" }}>
				<DetailsPanel
					header={customCaptions?.taskPlural}
					dataCount={totalCount}
					description={t("message.entityAssignedInThis", {
						entity: customCaptions?.taskPlural,
						parent: customCaptions?.modelTemplate,
					})}
				/>
				<TaskSearchFilters
					searchText={search}
					setSearchText={onSearchChange}
					chips={chips}
					autocompleteData={autocompleteData}
					isSearching={isSearchingSuggestions}
					handleSelectSuggestion={handleSelectSuggestion}
					customCaptions={customCaptions}
					classes={classes}
				/>
			</div>
			<div style={{ marginTop: 20 }}>
				<EMIChip data={chips} deleteHandler={removeChip} hideChips={[]} />
			</div>
			<ModelTaskTable
				data={rows}
				columnDefs={tableConfiguration.columnDefs}
				columns={tableConfiguration.columns}
				sorting={sorting}
				onSortingChange={onSortingChange}
				handleDelete={onDelete}
				deleteEndpoint={deleteEndpoint}
				handleCopy={onCopy}
				handleCopyTaskQuestion={onCopyTaskQuestion}
				modelId={modelId}
				customCaptions={customCaptions}
				totalTaskCount={totalCount}
				refreshData={onRefresh}
				access={access}
				isLoading={query.isPending}
				hasNextPage={query.hasNextPage}
				hasPreviousPage={query.hasPreviousPage}
				isFetchingNextPage={query.isFetchingNextPage}
				isFetchingPreviousPage={query.isFetchingPreviousPage}
				fetchNextPage={query.fetchNextPage}
				fetchPreviousPage={query.fetchPreviousPage}
				isFetchNextPageError={query.isFetchNextPageError}
				isFetchPreviousPageError={query.isFetchPreviousPageError}
				initialExpandedIds={initialExpandedIds}
				initialPrimaryId={initialPrimaryId}
				chips={chips}
			/>
		</>
	);
};

ModelTaskWorkspace.propTypes = {
	rows: PropTypes.array.isRequired,
	totalCount: PropTypes.number.isRequired,
	search: PropTypes.string.isRequired,
	onSearchChange: PropTypes.func.isRequired,
	chips: PropTypes.array,
	removeChip: PropTypes.func,
	autocompleteData: PropTypes.array,
	isSearchingSuggestions: PropTypes.bool,
	handleSelectSuggestion: PropTypes.func,
	tableConfiguration: PropTypes.object.isRequired,
	query: PropTypes.object.isRequired,
	deleteEndpoint: PropTypes.string.isRequired,
};

export default ModelTaskWorkspace;
